import Contact from "../../../components/Contact";
import Header from "../../../components/layout/Header";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";
const ContactPage = () => {
  const { language } = useLanguage();
  return (
    <Header
      title={`EatSalad - ${translate(
        translationsContent,
        "contactHeader",
        language
      )}`}
      description="Salade sur mesure à emporter et en livraison | Eat Salad"
      noindex={false}
      nofollow={false}
    >
      <Contact />
    </Header>
  );
};

export default ContactPage;
